export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Tabs.vue?vue&type=template&id=d6575fc8"


//////////////////
// WEBPACK FOOTER
// ./src/components/Tabs.vue?vue&type=template&id=d6575fc8
// module id = 1441
// module chunks = 31